module.exports = __webpack_public_path__ + "static/media/avatar3.f6d53da2.png";